import { SuperAdminModal } from '../../../baseComponents';
import { useDispatch } from 'react-redux';
import { AlertIcon } from 'src/icons';
import { useSelector } from 'react-redux';
import { deletePromptAction } from 'src/modules/SuperAdmin/store/actions/prompts.action';

const DeletePrompt = ({
  isOpen,
  setIsOpen,
  selectedSpecialty,
  selectedCondition,
}) => {
  const dispatch = useDispatch();
  const { getPromptById } = useSelector((state) => state?.promptsState);

  const sections = [
    {
      heading: (
        <>
          <div className="flex items-center gap-2 ">
            <AlertIcon />
            Remove prompt
          </div>
        </>
      ),
      fields: [],
    },
    {
      fields: [
        {
          type: 'label',
          title: (
            <>
              <span>Are you sure you want to remove this</span>
              <span className="font-bold ml-1">
                {getPromptById?.description} ?
              </span>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      className={`delete-modal`}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        dispatch(
          deletePromptAction(
            getPromptById?.prompt?.prompt_id,
            setIsOpen,
            selectedSpecialty,
            selectedCondition
          )
        );
      }}
    />
  );
};

export default DeletePrompt;
